export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/lowtohigh.94c05c8d.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};